import React from 'react';
const AkButton = /*#__PURE__*/React.lazy(() => import( /* webpackChunkName: '@atlaskit-internal_.button/custom-theme-button' */
'@atlaskit/button/custom-theme-button'));

// taken from https://hello.atlassian.net/wiki/spaces/PRODSEC/pages/158006558/URI+scheme+Allow+listing
const PROTOCOL_ALLOWLIST = ['http:', 'https:', 'ftp:', 'ftps:', 'mailto:', 'skype:', 'callto:', 'facetime:', 'git:', 'irc:', 'irc6:', 'news:', 'nntp:', 'feed:', 'cvs:', 'svn:', 'mvn:', 'ssh:', 'scp:', 'sftp:', 'itms:', 'notes:', 'hipchat:', 'sourcetree:', 'urn:', 'tel:', 'xmpp:', 'telnet:', 'vnc:', 'rdp:', 'whatsapp:', 'slack:', 'sip:', 'sips:', 'magnet:', 'tds:'];
export const sanitizeUrl = urlString => {
  const url = new URL(urlString || '', window.location.href);
  if (PROTOCOL_ALLOWLIST.includes(url.protocol)) {
    return url.toString();
  } else {
    return 'about:blank';
  }
};

// this is different to Rendered<T>, as ReactNode supports inline strings

export function Em({
  children
}) {
  return /*#__PURE__*/React.createElement("em", null, children);
}
export function Link({
  href,
  children,
  openNewTab,
  appearance
}) {
  const sanitizedHref = sanitizeUrl(href);
  if (appearance === 'primary-button' || appearance === 'button') {
    return /*#__PURE__*/React.createElement(AkButton, {
      appearance: appearance === 'primary-button' ? 'primary' : 'default',
      href: sanitizedHref,
      rel: "noopener noreferrer",
      target: openNewTab ? '_blank' : undefined
    }, children);
  } else {
    return /*#__PURE__*/React.createElement("a", {
      href: sanitizedHref,
      rel: "noopener noreferrer",
      target: openNewTab ? '_blank' : undefined
    }, children);
  }
}
export function Strike({
  children
}) {
  return /*#__PURE__*/React.createElement("s", null, children);
}
export function String({
  text
}) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, text);
}
export function Strong({
  children
}) {
  return /*#__PURE__*/React.createElement("strong", null, children);
}
function wrap(Component) {
  return function WrappedComponent({
    Components,
    children,
    props: propsAny,
    render,
    renderChildren,
    dispatch
  }) {
    const props = propsAny;
    return /*#__PURE__*/React.createElement(Component, props, renderChildren({
      Components,
      children,
      render,
      dispatch
    }));
  };
}
export const EmFn = wrap(Em);
export const LinkFn = wrap(Link);
export const StrikeFn = wrap(Strike);
export const StringFn = wrap(String);
export const StrongFn = wrap(Strong);